import React, { createContext, useContext, useState } from "react";
import { MenuItem } from "../../types/Response/CustomerResponse";



interface MenuContextType {
  menu: MenuItem[];
  setMenu: React.Dispatch<React.SetStateAction<MenuItem[]>>;
}

const MenuContext = createContext<MenuContextType>({
  menu: [],
  setMenu: () => {},
});

export const MenuProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [menu, setMenu] = useState<MenuItem[]>([]);

  return (
    <MenuContext.Provider value={{ menu, setMenu }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => useContext(MenuContext);